import { buildApplicableGradePayload } from "../../../components/utils/serialGradeFields";
import { cardFromSerial } from "../../../components/serials/tags/submitTagsFlow";

export function buildTagDataFromSerial(serial) {
  if (!serial) return null;
  return cardFromSerial(
    serial,
    buildApplicableGradePayload(serial, serial?.product || serial?.productData)
  );
}

export function buildTagsDataFromSerials(serials) {
  if (!Array.isArray(serials)) return [];
  return serials.map(buildTagDataFromSerial).filter(Boolean);
}

/** Ao habilitar seleção, todas as cartas começam desmarcadas (paridade desktop). */
export function enterSelectionMode(tagsData) {
  return tagsData.map((entry) => ({ ...entry, select: false }));
}

/** Ao cancelar seleção, todas as cartas voltam selecionadas (paridade desktop). */
export function exitSelectionMode(tagsData) {
  return tagsData.map((entry) => ({ ...entry, select: true }));
}

export function toggleCardSelect(tagsData, serialNumber, selected) {
  return tagsData.map((entry) =>
    entry.serial === serialNumber ? { ...entry, select: selected } : entry
  );
}

/** Se todas estão selecionadas, limpa; senão, seleciona todas. */
export function toggleSelectAll(tagsData) {
  const list = tagsData || [];
  const allSelected = list.length > 0 && list.every((entry) => entry?.select);
  return list.map((entry) => ({ ...entry, select: !allSelected }));
}

export function updateTagField(tagsData, serialNumber, field, value) {
  return tagsData.map((entry) =>
    entry.serial === serialNumber ? { ...entry, [field]: value } : entry
  );
}

export function getSelectedTags(tagsData) {
  return (tagsData ?? []).filter((entry) => entry?.select);
}

export function canGenerateTags(tagsData) {
  return getSelectedTags(tagsData).length > 0;
}

export function getCardError(errorData, serialNumber) {
  if (!errorData?.cards?.length) return null;
  return errorData.cards.find((card) => card.serial === serialNumber) ?? null;
}

export function getErrorFieldKeys(cardError) {
  return cardError?.fields?.map((field) => field.key) ?? [];
}

export function hasTagModelDiff(serial) {
  const tag = serial?.gradableModel?.tag;
  const model = serial?.gradableModel;
  if (!tag) return false;
  return (
    tag.name !== model?.name ||
    tag.rarity !== model?.rarity ||
    tag.edition !== model?.edition ||
    tag.year !== model?.year ||
    tag.language !== model?.language ||
    tag.numbering !== model?.numbering
  );
}
